import { Injectable } from '@angular/core';

const UTM_STORAGE_KEY = 'cm_utm_params';

@Injectable({
  providedIn: 'root',
})
export class CampaignService {
  private campaigns = [
    { id: 'registro', label: 'Registro' },
    { id: 'recarga', label: 'Recarga' },
    { id: 'compra', label: 'Compra' },
  ];
  constructor() {
    // Capturar UTM params al inicializar el servicio
    this.captureUTMParams();
  }

  getCampaignTypes() {
    return this.campaigns;
  }

  getCampaignLabel(id: string): string {
    return this.campaigns.find((c) => c.id === id)?.label || 'Desconocida';
  }

  /**
   * Captura los parámetros UTM de la URL y los guarda en sessionStorage
   * Solo guarda si hay al menos un parámetro UTM válido
   */
  captureUTMParams(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const utmFromUrl = this.extractUTMFromParams(urlParams);

    // Solo guardar si hay al menos un parámetro UTM válido
    if (this.hasValidUTMParams(utmFromUrl)) {
      sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(utmFromUrl));
    }
  }

  /**
   * Obtiene los parámetros UTM, primero de sessionStorage, luego de la URL
   */
  getUTMParams(): any {
    // Primero intentar obtener de sessionStorage
    const stored = sessionStorage.getItem(UTM_STORAGE_KEY);
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        if (this.hasValidUTMParams(parsed)) {
          return parsed;
        }
      } catch (e) {
        // Si hay error parseando, continuar con la URL
      }
    }

    // Si no hay en sessionStorage, obtener de la URL
    const urlParams = new URLSearchParams(window.location.search);
    return this.extractUTMFromParams(urlParams);
  }

  /**
   * Extrae los parámetros UTM de URLSearchParams
   */
  private extractUTMFromParams(urlParams: URLSearchParams): any {
    return {
      campaign_id: urlParams.get('campaign_id') || null,
      utm_id: urlParams.get('utm_id') || null,
      utm_source: urlParams.get('utm_source') || null,
      utm_medium: urlParams.get('utm_medium') || null,
      utm_campaign: urlParams.get('utm_campaign') || null,
      utm_term: urlParams.get('utm_term') || null,
      utm_content: urlParams.get('utm_content') || null,
      ad_id: urlParams.get('ad_id') || null,
      ref: urlParams.get('ref') || null,

      // IDs específicos de plataformas
      gclid: urlParams.get('gclid') || null,
      fbclid: urlParams.get('fbclid') || null,
      msclkid: urlParams.get('msclkid') || null,
      clid: urlParams.get('clid') || null,

      // Más opcionales
      creative_id: urlParams.get('creative_id') || null,
      placement: urlParams.get('placement') || null,
      device: urlParams.get('device') || null,
    };
  }

  /**
   * Verifica si hay al menos un parámetro UTM válido
   */
  private hasValidUTMParams(params: any): boolean {
    if (!params) return false;
    return Object.values(params).some((value) => value !== null && value !== '');
  }

  /**
   * Limpia los parámetros UTM guardados (útil para testing o reset)
   */
  clearUTMParams(): void {
    sessionStorage.removeItem(UTM_STORAGE_KEY);
  }
}
